import React, { useState } from 'react';
import { Formik, Field, ErrorMessage } from 'formik';
import styled from 'styled-components';

function useDisableFields(initialValues: any) {
  const [values, setValues] = useState(initialValues);

  const updateDisable = (name: any, disabled: any) => {
    setValues({ ...values, [name]: disabled });
  };

  return [values, updateDisable];
}

const FieldGroup = ({ children, edit, name, title }: any) => {
  const [disabled, setDisabled] = edit;
  return (
    <div className="fieldgroup">
      <FlexWrapper>
        <h3 className="field-title">{title}</h3>
        <button
          type="button"
          onClick={() => {
            setDisabled(name, !disabled[name]);
            console.log('disabled', disabled);
          }}
          className="edit-button"
        >
          {disabled[name] ? 'edit' : 'done'}
        </button>
      </FlexWrapper>
      {children}
    </div>
  );
};

const sendResponse = async (data: any) => {
  console.log('data', data);
  const xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://hooks.zapier.com/hooks/catch/13353927/3dl1bh9/');
  const response = await xhr.send(JSON.stringify(data));

  console.log('response', response);
  alert('Form Submitted Successfully');
  window.location.href = 'https://www.wheretoshoot.org/form-thank-you';
  return response;
};

const SingleForm = ({ form }: any) => {
  const [disabled, setDisabled] = useDisableFields({
    firstGroup: true,
    secondGroup: true,
    thirdGroup: true,
    fourthGroup: true,
    fifthGroup: true,
    sixthGroup: true,
    seventhGroup: true,
    eighthGroup: true
  });

  return (
    <Formik
      initialValues={form}
      onSubmit={values => {
        sendResponse(values);
      }}
    >
      {({ handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <FieldGroup
            name="firstGroup"
            edit={[disabled, setDisabled]}
            title="Facility or Range Information"
          >
            <div className="formrow">
              <div className="half">
                <label htmlFor="Applicants_Title__c">
                  Applicant's Title
                  <span className="red">*</span>
                </label>
                <Field
                  name="Applicants_Title__c"
                  as="select"
                  required
                  disabled={disabled.firstGroup}
                >
                  <option value="None">None</option>
                  <option value="Employee">Employee</option>
                  <option value="Customer">Customer</option>
                  <option value="Owner">Owner</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Shooting_Facility_Range_Name__c">
                  Range Name
                  <span className="red">*</span>
                </label>
                <Field
                  type="text"
                  name="Shooting_Facility_Range_Name__c"
                  disabled={disabled.firstGroup}
                  required
                />
              </div>
            </div>
            <div className="formrow">
              <div className="half">
                <label htmlFor="General_Email__c">General Email</label>
                <Field
                  type="email"
                  name="General_Email__c"
                  disabled={disabled.firstGroup}
                />
                <span className="check">
                  <Field
                    type="checkbox"
                    name="Display_Email_on_Website__c"
                    disabled={disabled.firstGroup}
                  />
{' '}
                  Display email on "Where to Shoot?"
                </span>
              </div>
              <div className="half">
                <label htmlFor="Web_Site_Address__c">Web Site Address</label>
                <Field
                  type="text"
                  id="Web_Site_Address__c"
                  name="Web_Site_Address__c"
                  disabled={disabled.firstGroup}
                />

                <span className="check">
                  <Field
                    type="checkbox"
                    name="WTS_Display_Web_URL__c"
                    disabled={disabled.firstGroup}
                  />
{' '}
                  Display your website on "Where to Shoot?"
                </span>
              </div>
            </div>

            <div className="formrow">
              <div className="half">
                <label htmlFor="Public_or_Private_Facility__c">
                  Facility Access 
{' '}
<span className="red">*</span>
                </label>
                <Field
                  as="select"
                  id="Public_or_Private_Facility__c"
                  name="Public_or_Private_Facility__c"
                  required
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Public">Public</option>
                  <option value="Private">Private</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Type_of_Facility__c">
                  Type of Facility 
{' '}
<span className="red">*</span>
                </label>
                <Field
                  as="select"
                  id="Type_of_Facility__c"
                  name="Type_of_Facility__c"
                  required
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Indoor">Indoor</option>
                  <option value="Outdoor">Outdoor</option>
                  <option value="Indoor/Outdoor">Indoor/Outdoor</option>
                </Field>
              </div>
            </div>

            <div className="formrow">
              <span className="check">
                <Field
                  type="checkbox"
                  name="Commercial_Range__c"
                  disabled={disabled.firstGroup}
                />
{' '}
                Commercial Range
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Law_Enforcement_Facility__c"
                  disabled={disabled.firstGroup}
                />
{' '}
                Law Enforcement Facility
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Municipal_Facility__c"
                  disabled={disabled.firstGroup}
                />
{' '}
                Municipal Facility (includes state, county, local government, or
                parks dept)
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Gun_Sportsman_s_Club__c"
                  disabled={disabled.firstGroup}
                />
{' '}
                Gun/Sportsman's Club
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Military_Facility__c"
                  disabled={disabled.firstGroup}
                />
{' '}
                Military Facility
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Hunting_Preserve__c"
                  disabled={disabled.firstGroup}
                />
{' '}
                Hunting Preserve
              </span>
            </div>

            <div className="formrow">
              <div className="half">
                <label htmlFor="Handicap_Accessible__c">
                  Handicap Accessible
                </label>
                <Field
                  as="select"
                  id="Handicap_Accessible__c"
                  name="Handicap_Accessible__c"
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Public_Access__c">Public Access</label>
                <Field
                  as="select"
                  id="Public_Access__c"
                  name="Public_Access__c"
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Members_Only__c">Members Only</label>
                <Field
                  as="select"
                  id="Members_Only__c"
                  name="Members_Only__c"
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Memberships_Available__c">
                  Memberships Available
{' '}
                </label>
                <Field
                  as="select"
                  id="Memberships_Available__c"
                  name="Memberships_Available__c"
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Host_Events_Open_To_Public_Non_Members__c">
                  Host Events Open To Public / Non-Members
{' '}
                </label>
                <Field
                  as="select"
                  id="Host_Events_Open_To_Public_Non_Members__c"
                  name="Host_Events_Open_To_Public_Non_Members__c"
                  disabled={disabled.firstGroup}
                >
                  <option value="">None</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
              </div>
            </div>
          </FieldGroup>

          <div className="fieldgroup">
            <FlexWrapper>
              <h3 className="field-title">Physical Location Information</h3>
            </FlexWrapper>
            <p>
              <span className="red">*</span>
              If you need to make any adjustments to your physical/mailing
              address, please email Ann Gamauf at
{' '}
              <a
                href={`mailto: agamauf@nssf.org?subject=LYR Form ID ${form.Name}`}
              >
                agamauf@nssf.org
              </a>
{' '}
              directly with these updates. Please reference listing #
{form.Name}{' '}
              in the Subject of your email.
            </p>
            {/* <p>
              Enter the physical address of your range in the 'Range Address'
              box and click "Address Lookup." The form will populate with the
              information needed to map your location appropriately. Please
              note, <em>only google-validated addresses are accepted.</em>
            </p> */}
            {/* <label htmlFor="address">
              Range Address <span className="red">*</span>
            </label>
            <Field
              type="text"
              id="address"
              name="address"
              required
              disabled={disabled.secondGroup}
            /> */}
            {/* <div>
              <a href="#" id="clear-address" className="button">
                Clear Address
              </a>
              <a href="#" id="address-lookup" className="button">
                Address Lookup
              </a>
            </div>
            <div id="address-error">
              The address you entered cannot be validated and mapped properly.
              If you feel this is in error, please contact Ann Gamauf{' '}
              <a href="mailto:agamauf@nssf.org">agamauf@nssf.org</a> to discuss
              this matter further.
            </div> */}

            <div className="generated empty">
              <div className="formrow">
                <div className="half">
                  <label htmlFor="Address__c">
                    Address 
{' '}
<span className="red">*</span>:
{' '}
                  </label>
                  <Field
                    type="text"
                    id="Address__c"
                    name="Address__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
                <div className="half">
                  <label htmlFor="City__c">
                    City: 
{' '}
<span className="red">*</span>{' '}
                  </label>
                  <Field
                    type="text"
                    id="City__c"
                    name="City__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
                <div className="half">
                  <label htmlFor="State__c">
                    State 
{' '}
<span className="red">*</span>:
{' '}
                  </label>
                  <Field
                    type="text"
                    id="State__c"
                    name="State__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
                <div className="half">
                  <label htmlFor="Country__c">
                    Country 
{' '}
<span className="red">*</span>:
{' '}
                  </label>
                  <Field
                    type="text"
                    id="Country__c"
                    name="Country__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
                <div className="half">
                  <label htmlFor="ZIP__c">
                    Zip 
{' '}
<span className="red">*</span>:
{' '}
                  </label>
                  <Field
                    type="text"
                    id="ZIP__c"
                    name="ZIP__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
                <div className="half">
                  <label htmlFor="Latitude__c">
                    Latitude 
{' '}
<span className="red">*</span>:
{' '}
                  </label>
                  <Field
                    type="text"
                    id="Latitude__c"
                    name="Latitude__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
                <div className="half">
                  <label htmlFor="Longitude__c">
                    Longitude 
{' '}
<span className="red">*</span>:
{' '}
                  </label>
                  <Field
                    type="text"
                    id="Longitude__c"
                    name="Longitude__c"
                    required
                    disabled={disabled.secondGroup}
                  />
                </div>
              </div>
            </div>
          </div>

          <FieldGroup
            name="thirdGroup"
            edit={[disabled, setDisabled]}
            title="Mailing Information"
          >
            <div className="formrow">
              <div className="half">
                <label htmlFor="Mailing_Address__c">Address</label>
                <Field
                  type="text"
                  id="Mailing_Address__c"
                  name="Mailing_Address__c"
                  disabled={disabled.thirdGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Mailing_City__c">City</label>
                <Field
                  type="text"
                  id="Mailing_City__c"
                  name="Mailing_City__c"
                  disabled={disabled.thirdGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Mailing_State__c">State</label>
                <Field
                  as="select"
                  id="Mailing_State__c"
                  name="Mailing_State__c"
                  disabled={disabled.thirdGroup}
                >
                  <option value="">--Select State--</option>
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Mailing_ZIP__c">Zip</label>
                <Field
                  type="text"
                  id="Mailing_ZIP__c"
                  name="Mailing_ZIP__c"
                  disabled={disabled.thirdGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Mailing_Country__c">Country</label>
                <Field
                  type="text"
                  id="Mailing_Country__c"
                  name="Mailing_Country__c"
                  disabled={disabled.thirdGroup}
                />
              </div>
            </div>
          </FieldGroup>

          <FieldGroup
            name="fourthGroup"
            edit={[disabled, setDisabled]}
            title="Phone Information"
          >
            <div className="formrow">
              <div className="half">
                <label htmlFor="Main_Phone__c">
                  Main Phone 
{' '}
<span className="red">*</span>
                </label>
                <Field
                  disabled={disabled.fourthGroup}
                  type="text"
                  id="Main_Phone__c"
                  name="Main_Phone__c"
                  required
                />
                <span className="check">
                  <Field
                    disabled={disabled.fourthGroup}
                    type="checkbox"
                    name="Display_Main_Phone_on_Website__c"
                  />
{' '}
                  Display Main Phone on website?
                </span>
              </div>
              <div className="half">
                <label htmlFor="Toll_Free__c">Toll Free</label>
                <Field
                  disabled={disabled.fourthGroup}
                  type="text"
                  id="Toll_Free__c"
                  name="Toll_Free__c"
                />

                <span className="check">
                  <Field
                    disabled={disabled.fourthGroup}
                    type="checkbox"
                    name="Display_Toll_Free_On_Website__c"
                  />
{' '}
                  Display Toll Free# on website?
                </span>
              </div>
              <div className="half">
                <label htmlFor="Fax__c">FAX</label>
                <Field
                  disabled={disabled.fourthGroup}
                  type="text"
                  id="Fax__c"
                  name="Fax__c"
                />

                <span className="check">
                  <Field
                    disabled={disabled.fourthGroup}
                    type="checkbox"
                    name="Display_Fax_on_Website__c"
                  />
{' '}
                  Display FAX on website?
                </span>
              </div>
            </div>

            <div className="formrow">
              <div className="half">
                <label htmlFor="Other_Phone__c">Other Phone 1</label>
                <Field
                  disabled={disabled.fourthGroup}
                  type="text"
                  id="Other_Phone__c"
                  name="Other_Phone__c"
                />
              </div>
              <div className="half">
                <label htmlFor="Other_Phone_Type__c">Other Phone 1 Type</label>
                <Field
                  as="select"
                  id="Other_Phone_Type__c"
                  name="Other_Phone_Type__c"
                  disabled={disabled.fourthGroup}
                >
                  <option value="">--None--</option>
                  <option value="Daytime">Daytime</option>
                  <option value="Cell">Cell</option>
                  <option value="Registration">Registration</option>
                  <option value="Evening">Evening</option>
                  <option value="General">General</option>
                  <option value="Primary">Primary</option>
                  <option value="Secondary">Secondary</option>
                  <option value="Range">Range</option>
                  <option value="Contact">Contact</option>
                  <option value="Info">Info</option>
                  <option value="Voicemail">Voicemail</option>
                  <option value="Clubhouse">Clubhouse</option>
                </Field>

                <span className="check">
                  <Field
                    disabled={disabled.fourthGroup}
                    type="checkbox"
                    name="Display_Other_On_Website__c"
                  />
{' '}
                  Display Other Phone 1 on website?
                </span>
              </div>
            </div>
          </FieldGroup>

          <FieldGroup
            name="fifthGroup"
            edit={[disabled, setDisabled]}
            title="Primary Contact"
          >
            <div className="formrow">
              <div className="half">
                <label htmlFor="First_Name__c">
                  First Name 
{' '}
<span className="red">*</span>
                </label>
                <Field
                  type="text"
                  id="First_Name__c"
                  name="First_Name__c"
                  required
                  disabled={disabled.fifthGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Last_Name__c">
                  Last Name 
{' '}
<span className="red">*</span>
                </label>
                <Field
                  type="text"
                  id="Last_Name__c"
                  name="Last_Name__c"
                  required
                  disabled={disabled.fifthGroup}
                />
              </div>
            </div>
            <div className="formrow">
              <div className="half">
                <label htmlFor="Primary_Contact_Email__c">
                  Email 
{' '}
<span className="red">*</span>
                </label>
                <Field
                  type="email"
                  id="Primary_Contact_Email__c"
                  name="Primary_Contact_Email__c"
                  required
                  disabled={disabled.fifthGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Primary_Contact_Title__c">Contact Title</label>
                <Field
                  as="select"
                  id="Primary_Contact_Title__c"
                  name="Primary_Contact_Title__c"
                  disabled={disabled.fifthGroup}
                >
                  <option value="">--None--</option>
                  <option value="Owner">Owner</option>
                  <option value="Full-Time Paid Manager">
                    Full-Time Paid Manager
                  </option>
                  <option value="Part-Time Paid Manager">
                    Part-Time Paid Manager
                  </option>
                  <option value="Volunteer (Club Officer, etc.)">
                    Volunteer (Club Officer, etc.)
                  </option>
                </Field>
              </div>
            </div>
            <div className="formrow">
              <div className="half">
                <label htmlFor="Primary_Contact_Phone__c">Phone</label>
                <Field
                  type="text"
                  id="Primary_Contact_Phone__c"
                  name="Primary_Contact_Phone__c"
                  disabled={disabled.fifthGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Primary_Contact_Address__c">Address</label>
                <Field
                  type="text"
                  id="Primary_Contact_Address__c"
                  name="Primary_Contact_Address__c"
                  disabled={disabled.fifthGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Primary_Contact_City__c">City</label>
                <Field
                  type="text"
                  id="Primary_Contact_City__c"
                  name="Primary_Contact_City__c"
                  disabled={disabled.fifthGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Primary_Contact_State__c">State</label>
                <Field
                  as="select"
                  id="Primary_Contact_State__c"
                  name="Primary_Contact_State__c"
                  disabled={disabled.fifthGroup}
                >
                  <option value="">--Select State--</option>
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </Field>
              </div>
              <div className="half">
                <label htmlFor="Primary_Contact_ZIP__c">Zip</label>
                <Field
                  type="text"
                  id="Primary_Contact_ZIP__c"
                  name="Primary_Contact_ZIP__c"
                  disabled={disabled.fifthGroup}
                />
              </div>
              <div className="half">
                <label htmlFor="Primary_Contact_Country__c">Country</label>
                <Field
                  as="select"
                  id="Primary_Contact_Country__c"
                  name="Primary_Contact_Country__c"
                  disabled={disabled.fifthGroup}
                >
                  <option value="USA">USA</option>
                </Field>
              </div>
            </div>
          </FieldGroup>

          <FieldGroup
            name="sixthGroup"
            edit={[disabled, setDisabled]}
            title="Range Details"
          >
            <h4>NSSF Publications</h4>
            <span className="check">
              <Field
                type="checkbox"
                name="Bullet_Points__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Bullet Points
            </span>
            <span className="check">
              <Field
                type="checkbox"
                name="First_Shots__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              First Shots
            </span>
            <span className="check">
              <Field
                type="checkbox"
                name="Pull_The_Trigger__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Pull The Trigger
            </span>
            <h4>Range Details- Shooting Available - Shotgun</h4>
            <p>Check all that apply</p>
            <div className="formrow">
              <span className="check">
                <Field
                  type="checkbox"
                  name="Trap__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                Trap
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Skeet__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                Skeet
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Informal_Practice_Area__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                Informal Practice Area
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Bunker_Trap__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                Bunker Trap
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="International_Skeet__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                International Skeet
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Other_Shotgun__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                Other Shotgun
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="X5_Stand__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                5-Stand
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Sporting_Clays__c"
                  disabled={disabled.sixthGroup}
                />
{' '}
                Sporting Clays
              </span>
            </div>

            <h4>Range Details- Shooting Available - Center Fire Rifle</h4>
            <div className="formrow">
              <div className="half">
                <span className="check">
                  <Field
                    type="checkbox"
                    name="Indoor_Center_Fire_Rifle__c"
                    id="Indoor_Center_Fire_Rifle__c"
                    disabled={disabled.sixthGroup}
                  />
{' '}
                  Indoor
                </span>
                <label htmlFor="Indoor_Center_Maximum_Shooting_Distance__c">
                  {' '}
                  Maximum Indoor Shooting Distance
                </label>
                <Field
                  as="select"
                  id="Indoor_Center_Maximum_Shooting_Distance__c"
                  name="Indoor_Center_Maximum_Shooting_Distance__c"
                  disabled={disabled.sixthGroup}
                >
                  <option value="">--None--</option>
                  <option value="50 ft">50 ft</option>
                  <option value="75 ft">75 ft</option>
                  <option value="50 yd/mtr">50 yd/mtr</option>
                  <option value="100 yd/mtr">100 yd/mtr</option>
                </Field>
              </div>
              <div className="half">
                <span className="check">
                  <Field
                    type="checkbox"
                    name="Outdoor_Center_Fire_Rifle__c"
                    id="Outdoor_Center_Fire_Rifle__c"
                    disabled={disabled.sixthGroup}
                  />
{' '}
                  Outdoor
                </span>
                <label htmlFor="Outdoor_Center_Maximum_Shooting_Distance__c">
                  Maximum Outdoor Shooting Distance
                </label>
                <Field
                  as="select"
                  id="Outdoor_Center_Maximum_Shooting_Distance__c"
                  name="Outdoor_Center_Maximum_Shooting_Distance__c"
                  disabled={disabled.sixthGroup}
                >
                  <option value="">--None--</option>
                  <option value="50 ft">50 ft</option>
                  <option value="75 ft">75 ft</option>
                  <option value="50 yd/mtr">50 yd/mtr</option>
                  <option value="100 yd/mtr">100 yd/mtr</option>
                  <option value="1000 yd/mtr">1000 yd/mtr</option>
                </Field>
              </div>
            </div>

            <h4>Range Details- Shooting Available - Handgun/Smallbore Rifle</h4>

            <div className="formrow">
              <div className="half">
                <span className="check">
                  <Field
                    type="checkbox"
                    name="Indoor_Handgun_Smallbore_Rifle__c"
                    id="Indoor_Handgun_Smallbore_Rifle__c"
                    disabled={disabled.sixthGroup}
                  />
{' '}
                  Indoor
                </span>
                <label htmlFor="Indoor_Handgun_Shooting_Distance__c">
                  Maximum Indoor Shooting Distance
                </label>
                <Field
                  as="select"
                  id="Indoor_Handgun_Shooting_Distance__c"
                  name="Indoor_Handgun_Shooting_Distance__c"
                  disabled={disabled.sixthGroup}
                >
                  <option value="">--None--</option>
                  <option value="50 ft">50 ft</option>
                  <option value="75 ft">75 ft</option>
                  <option value="50 yd/mtr">50 yd/mtr</option>
                  <option value="100 yd/mtr">100 yd/mtr</option>
                </Field>
              </div>
              <div className="half">
                <span className="check">
                  <Field
                    type="checkbox"
                    name="Outdoor_Handgun_Smallbore_Rifle__c"
                    id="Outdoor_Handgun_Smallbore_Rifle__c"
                    disabled={disabled.sixthGroup}
                  />
{' '}
                  Outdoor
                </span>
                <label htmlFor="Outdoor_Handgun_Shooting_Distance__c">
                  Maximum Outdoor Shooting Distance
                </label>
                <Field
                  as="select"
                  id="Outdoor_Handgun_Shooting_Distance__c"
                  name="Outdoor_Handgun_Shooting_Distance__c"
                  disabled={disabled.sixthGroup}
                >
                  <option value="">--None--</option>
                  <option value="50 ft">50 ft</option>
                  <option value="75 ft">75 ft</option>
                  <option value="50 yd/mtr">50 yd/mtr</option>
                  <option value="100 yd/mtr">100 yd/mtr</option>
                  <option value="1000 yd/mtr">1000 yd/mtr</option>
                </Field>
              </div>
            </div>

            <h4>Range Details- Shooting Available - Archery</h4>

            <span className="check">
              <Field
                type="checkbox"
                name="Archery_Indoor__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Indoor
            </span>
            <span className="check">
              <Field
                type="checkbox"
                name="Archery_Outdoor_Field__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Outdoor Field
            </span>
            <span className="check">
              <Field
                type="checkbox"
                name="Archery_Outdoor_3_D__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Outdoor 3-D
            </span>

            <h4>Range Details - Shooting Available</h4>
            <span className="check">
              <Field
                type="checkbox"
                name="Airgun__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Airgun
            </span>
            <span className="check">
              <Field
                type="checkbox"
                name="Muzzle_Loaders_Outdoor__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Outdoor
            </span>
            <span className="check">
              <Field
                type="checkbox"
                name="Range_Simulators__c"
                disabled={disabled.sixthGroup}
              />
{' '}
              Range Simulators
            </span>
          </FieldGroup>

          <FieldGroup
            name="seventhGroup"
            edit={[disabled, setDisabled]}
            title="Range Services"
          >
            <h4>Organized Competitions</h4>

            <div className="formrow">
              <span className="check">
                <Field
                  type="checkbox"
                  name="X3_D_Archery__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                3-D Archery
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="X3_Gun_Multi_Gun__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                3 Gun / Multi Gun
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="AirGuns__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Airgun
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Bench_Rest__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Bench Rest
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Cowboy_Action_Shooting__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Cowboy Action Shooting
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Handgun_Metallic_Silhouette__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Handgun Metallic Silhouette
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Hi_Power_Rifle_Matches__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Hi-Power Rifle Matches
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Muzzle_Loading_Events__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Muzzle Loading Events
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Practical_Action_Pistol__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Practical/Action Pistol
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Precision_Pistol__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Precision Pistol
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Rifle_Metallic_Silhouette__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Rifle Metallic Silhouette
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Rimfire_Challenge__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Rimfire Challenge
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Skeet_Competition__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Skeet
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Smallbore__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Smallbore
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Sporting_Clays_FITASC__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Sporting Clays/FITASC
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Trap_Competition__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Trap
              </span>
            </div>

            <h4>Services Available</h4>

            <div className="formrow">
              <span className="check">
                <Field
                  type="checkbox"
                  name="Camper_RV_Sites__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Camper/RV Sites
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Clubhouse_Lounge_Lodge__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Clubhouse/Lounge/Lodge
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Equipment_Rentals__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Equipment Rentals
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Food_Service_Snacks__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Food Service/Snacks
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Hunter_Education__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Hunter Education
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Instruction_Available__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Instruction Available
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Junior_Rifle__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Junior Rifle
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Lodging_Available__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Lodging Available
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Picnic_Area__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Picnic Area
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Retail_Store__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Retail Store
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Women_s_Programs__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Women's Programs
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Youth_Programs__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Youth Programs
              </span>
            </div>

            <h4>Hunting Available</h4>

            <div className="formrow">
              <span className="check">
                <Field
                  type="checkbox"
                  name="Chukar__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Chukar
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Deer__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Deer
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Dove__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Dove
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Duck__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Duck
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Geese__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Geese
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Grouse__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Grouse
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Hun__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Hun
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Partridge__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Partridge
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Pheasant__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Pheasant
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Prairie_Chicken__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Prairie Chicken
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Quail__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Quail
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Sage_Grouse__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Sage Grouse
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Sharp_Tailed_Grouse__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Sharp-Tailed Grouse
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Snipe__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Snipe
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Turkey__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Turkey
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Woodcock__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Woodcock
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Other__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Other
              </span>
              <span className="check">
                <Field
                  type="checkbox"
                  name="Fishing_Opportunities__c"
                  disabled={disabled.seventhGroup}
                />
{' '}
                Fishing Opportunities
              </span>
            </div>
          </FieldGroup>

          <FieldGroup
            name="eighthGroup"
            edit={[disabled, setDisabled]}
            title="Interested in your business becoming an NSSF Member?"
          >
            <p>
              Would you like your business to appear at the top of our list in
              bold type?
              <p>
                It can if you become an NSSF Member. And this is just one of the
                many benefits available to you when you become a Member.
              </p>
              <span className="check">
                <input
                  type="checkbox"
                  name="Please_check_box_to_receive_information__c"
                  disabled={disabled.eighthGroup}
                />
{' '}
                Please check box to receive information on becoming an NSSF
                Member.
              </span>
            </p>
          </FieldGroup>

          <div className="formrow">
            <div className="half">
              <label htmlFor="Your_name">
                Please Enter Your First and Last Name
                <span className="red">*</span>
              </label>
              <Field name="Your_name" type="text" required />
            </div>
            <div className="half">
              <label htmlFor="Your_relation">
                Please Enter Your Relationship to this Range
                <span className="red">*</span>
              </label>
              <Field type="text" name="Your_relation" required />
            </div>
          </div>

          <Button type="submit" disabled={isSubmitting}>
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default SingleForm;

const Form = styled.form`
  box-sizing: border-box;
  .field-title {
    display: inline-block;
    margin: 0 0 10px;
    font-size: 22px;
    font-weight: normal;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0px 5px;
  }

  .fieldgroup {
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #e6e6e6;

    p {
      font-size: 12px;
    }
  }

  input[type='text'],
  input[type='email'],
  input {
    border: 1px solid;
  }

  input[type='text'],
  input[type='email'],
  input[type='phone'] {
    width: 100%;
  }

  span.check {
    display: inline-block;
    width: 100%;
    vertical-align: middle;
    line-height: 1;
    box-sizing: border-box;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 0;
  }

  .formrow {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    justify-content: space-between;
    align-content: flex-start;
    align-items: flex-start;
    margin-left: -10px;
    margin-right: -10px;
    font-size: 14px;

    .half {
      width: 50%;
      padding: 0 10px;
      box-sizing: border-box;

      span.check {
        padding: 0;
        margin-top: 0;
      }
    }

    span.check {
      display: inline-block;
      width: 50%;
      margin: 0;
      vertical-align: middle;
      line-height: 1;
      padding: 0 10px;
      font-size: 12px;
      margin-top: 10px;
    }
  }

  label {
    display: block;
    margin: 10px 0px 5px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #4a6568;
  }

  .error,
  .red {
    color: red !important;
    border-color: red !important;
    font-weight: bold !important;
  }

  select {
    display: block !important;
    width: 100%;
    border: 1px solid #999;
    margin-left: 0;
    margin-bottom: 0px;
  }

  button {
    height: 36px;
    padding-top: 0px;
    padding-bottom: 0px;
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 1px;
    font-weight: bold;
  }

  select[disabled],
  input[disabled] {
    border: none !important;
    padding: 0 !important;
    background: transparent;
    line-height: 1.3;
    height: auto;
    font-weight: normal;
    font-family: sans-serif;
    margin-bottom: 10px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    display: block;
  }

  input[type='checkbox'][disabled] {
    -webkit-appearance: checkbox;
    appearance: checkbox;
    -moz-appearance: checkbox;
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
`;

const Button = styled.button`
  margin-top: 20px;
`;
